import { useEffect, useCallback } from 'react';

export function useIdleTimeout(onIdle: () => void, idleMinutes = 30) {
  const stableOnIdle = useCallback(onIdle, [onIdle]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(stableOnIdle, idleMinutes * 60 * 1000);
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [stableOnIdle, idleMinutes]);
}
